import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInWeeks
} from "date-fns";
import { formatToTimeZone } from "date-fns-timezone"

export const formatDateUS = (date: Date): string => {
  let dd = date.getDate().toString();
  let mm = (date.getMonth() + 1).toString();
  const yy = date.getFullYear().toString().slice(-2);

  dd = dd.length === 1 ? "0" + dd : dd;
  mm = mm.length === 1 ? "0" + mm : mm;

  return `${mm}/${dd}/${yy}`;
};

export const formatOrdersDate = (date: Date, timeZone: string): string => {
  const orderFormatDate = 'MM-DD-YYYY HH:mm';
  return formatToTimeZone(date.toUTCString(), orderFormatDate, { timeZone });
}

export const formatDate = (time: string) => {
  const messageDate = new Date(time);
  const currentDate = new Date();

  if (differenceInMinutes(currentDate, messageDate) < 1) {
    return "Just now";
  } else if (differenceInMinutes(currentDate, messageDate) < 60) {
    return `${differenceInMinutes(currentDate, messageDate)}m ago`;
  } else if (differenceInHours(currentDate, messageDate) < 24) {
    return `${differenceInHours(currentDate, messageDate)}hr ago`;
  } else if (differenceInDays(currentDate, messageDate) < 7) {
    return `${differenceInDays(currentDate, messageDate)}d ago`;
  } else if (differenceInWeeks(currentDate, messageDate) < 4) {
    return `${differenceInWeeks(currentDate, messageDate)}w ago`;
  } else if (differenceInMonths(currentDate, messageDate) < 12) {
    return `${differenceInMonths(currentDate, messageDate)}mo ago`;
  } else {
    return messageDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
};

export const formatTime = (time: string) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(time);
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};
